/**
 * Runtime configuration for client-side environment variables.
 *
 * Instead of baking NEXT_PUBLIC_* vars into the JS bundle at build time,
 * these values are injected at runtime via an inline <script> in layout.tsx.
 * This allows a single Docker image to serve all environments.
 *
 * - Client: reads from window.__RUNTIME_CONFIG__ (set by inline script in HTML <head>)
 * - Server (SSR): reads from process.env (k8s env vars at runtime)
 */

export interface RuntimeConfig {
  apiUrl: string;
  wsUrl: string;
  frontendUrl: string;
  disableAuth: boolean;
  samplesCdnUrl: string;
  debugLevel: string;
  posthogKey: string;
  posthogHost: string;
  defaultLocale: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

const EMPTY_CONFIG: RuntimeConfig = {
  apiUrl: '',
  wsUrl: '',
  frontendUrl: '',
  disableAuth: false,
  samplesCdnUrl: '',
  debugLevel: '',
  posthogKey: '',
  posthogHost: '',
  defaultLocale: 'en',
};

/**
 * Get runtime configuration.
 *
 * On client: returns window.__RUNTIME_CONFIG__ (injected by server in HTML <head>).
 * On server (SSR): reads from process.env at runtime (real k8s env vars).
 *
 * The typeof window check is recognized by webpack for dead-code elimination,
 * ensuring the server branch (with process.env reads) is tree-shaken from
 * client bundles — no build-time values leak into static chunks.
 */
export function getRuntimeConfig(): RuntimeConfig {
  // Client: use runtime config injected by layout.tsx <script> tag
  if (typeof window !== 'undefined') {
    return window.__RUNTIME_CONFIG__ || EMPTY_CONFIG;
  }

  // Server (SSR): read real process.env at request time.
  // This branch is tree-shaken from client bundles by webpack.
  return {
    apiUrl: process.env['NEXT_PUBLIC_API_URL_CLIENT_SIDE'] || '',
    wsUrl: process.env['NEXT_PUBLIC_WS_URL_BACKEND_SIDE'] || '',
    frontendUrl: process.env['NEXT_PUBLIC_FRONTEND_URL'] || '',
    disableAuth: process.env['NEXT_PUBLIC_DISABLE_AUTH'] === 'true',
    samplesCdnUrl: process.env['NEXT_PUBLIC_SAMPLES_CDN_URL'] || '',
    debugLevel: process.env['NEXT_PUBLIC_DEBUG_LEVEL'] || '',
    posthogKey: process.env['NEXT_PUBLIC_POSTHOG_KEY'] || '',
    posthogHost: process.env['NEXT_PUBLIC_POSTHOG_HOST'] || '',
    defaultLocale: process.env['NEXT_PUBLIC_DEFAULT_LOCALE'] || 'en',
  };
}
